(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facility-filter"] && !Shopify.designMode) return;
  try {
    (function () {
  const lsAllSelects = document.querySelectorAll('[data-locationselect]');
  let lsCurrentlyOpen = null;

  lsAllSelects.forEach(function (lsRoot) {
    const lsTriggerBtn = lsRoot.querySelector('.select-trigger');
    const lsOptionsList = lsRoot.querySelector('.select-options');
    const lsPlaceholderText = lsRoot.querySelector('.placeholder');
    const lsClearButton = lsRoot.querySelector('.clear-btn');
    const lsRadioInputs = lsRoot.querySelectorAll('input[type="radio"]');
    const blogUrl = lsRoot.dataset.blogUrl;

function getCurrentNonLocationTag() {
  const path = window.location.pathname;
  if (!path.includes('/tagged/')) return null;
  const tagged = path.split('/tagged/')[1];
  const parts = tagged.split('+');
  return parts.find(function(p) { 
    return !p.includes('location') && !p.includes('facility'); 
  }) || null;
}

    function lsUpdatePlaceholder() {
  let selected = null;
  lsRadioInputs.forEach(function (radio) {
    if (radio.checked && radio.value !== '') selected = radio.value;
  });
  lsPlaceholderText.textContent = selected || 'Filter by facility type';
}

    function lsCloseDropdown() {
      lsOptionsList.style.display = 'none';
      lsTriggerBtn.setAttribute('aria-expanded', 'false');
    }

    lsTriggerBtn.addEventListener('click', function (event) {
      event.stopPropagation();

      if (lsCurrentlyOpen && lsCurrentlyOpen !== lsRoot) {
        const prevOptions = lsCurrentlyOpen.querySelector('.select-options');
        const prevTrigger = lsCurrentlyOpen.querySelector('.select-trigger');
        prevOptions.style.display = 'none';
        prevTrigger.setAttribute('aria-expanded', 'false');
      }

      const lsIsOpen = lsOptionsList.style.display === 'block';
      if (lsIsOpen) {
        lsCloseDropdown();
        lsCurrentlyOpen = null;
      } else {
        lsOptionsList.style.display = 'block';
        lsTriggerBtn.setAttribute('aria-expanded', 'true');
        lsCurrentlyOpen = lsRoot;
      }
    });

    lsRadioInputs.forEach(function (radio) {
  radio.addEventListener('change', function () {
    lsUpdatePlaceholder();
    const nonLocationTag = getCurrentNonLocationTag();
    if (!radio.dataset.tagHandle) {
      window.location.href = nonLocationTag ? blogUrl + '/tagged/' + nonLocationTag : blogUrl;
      return;
    }
    let url = blogUrl + '/tagged/';
    if (nonLocationTag) url += nonLocationTag + '+';
    url += radio.dataset.tagHandle;
    window.location.href = url;
  });
});

    lsClearButton.addEventListener('click', function (e) {
      e.preventDefault();
      lsRadioInputs.forEach(function (radio) {
        radio.checked = false;
      });
      lsUpdatePlaceholder();
      const nonLocationTag = getCurrentNonLocationTag();
      window.location.href = nonLocationTag ? blogUrl + '/tagged/' + nonLocationTag : blogUrl;
    });

    // Initial sync on load — runs before paint to avoid flash
    lsUpdatePlaceholder();

    document.addEventListener('click', function () {
      lsCloseDropdown();
      lsCurrentlyOpen = null;
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
